import React from 'react';
import PropTypes from 'prop-types';
import { Scrollbar } from 'components';

import './form-tile-body.scss';

export class FormTileBody extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node,
    onUpdateScroll: PropTypes.func,
    withOverflow: PropTypes.bool,
  };

  static defaultProps = {
    children: null,
    onUpdateScroll: () => {},
    withOverflow: false,
  };

  render() {
    const { children, onUpdateScroll, withOverflow } = this.props;

    return (
      <Scrollbar
        withOverflow={withOverflow}
        onUpdate={onUpdateScroll}
        disableTrackXWidthCompensation={false}
      >
        <div className="form-tile-body">
          <div className="form-tile-body__content">{children}</div>
        </div>
      </Scrollbar>
    );
  }
}
FormTileBody.displayName = 'FormTileBody';
